var quantityLabel = "Menge";
var quantityFlyoutHeader = "Bestellmenge auswählen";
var quantityFlyoutCTA = "Diese Menge auswählen";
var closeButton = "Schließen";
var pricePlaceholder = "...";
var priceLabel = "Preis";
var unitPriceLabel = "Stückpreis";
var incompatibilityMessage = "Nicht mit anderen Optionen verfügbar: ";
var select = "Auswählen...";
var percentSavings = "{{{PERCENT}}} % Ersparnis";
var sale = "Sale";
var amountSavings = "{{{AMOUNT}}} Ersparnis / Stück";
var amountSavingsWithSale = "{{{AMOUNT}}} Ersparnis / Stück + Sale";
var seeMoreQuantities = "Weitere Mengen";
var required = "Erforderlich";
var sample = "Muster";
var estimatedQuantity = "Voraussichtliche Menge";
var numberOfRecipients = "{{{COUNT}}} Personen";
var recommendedCallout = "Unsere Empfehlung";
var newCallout = "Neu";
var incompatibleLabel = "Nicht kombinierbar";
var outOfStockCallout = "Nicht auf Lager";
var dismissAlert = "Warnung schließen";
var unwindingMessage_1 = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}}.";
var unwindingMessage_2 = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}} und {{{ATTRIBUTE2}}} {{{OPTION2}}}.";
var unwindingMessage_3 = "Nicht kombinierbar mit {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} und {{{ATTRIBUTE3}}} {{{OPTION3}}}.";
var unwindingMessage_more = "Nicht kombinierbar mit mehr als {{{ATTRIBUTE_COUNT}}} Optionen.";
var unwindingAlertMessage_1 = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurde {{{ATTRIBUTE1}}} {{{OPTION1}}} abgewählt.";
var unwindingAlertMessage_2 = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden {{{ATTRIBUTE1}}} {{{OPTION1}}} und {{{ATTRIBUTE2}}} {{{OPTION2}}} abgewählt.";
var unwindingAlertMessage_3 = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden {{{ATTRIBUTE1}}} {{{OPTION1}}}, {{{ATTRIBUTE2}}} {{{OPTION2}}} und {{{ATTRIBUTE3}}} {{{OPTION3}}} abgewählt.";
var unwindingAlertMessage_more = "Für die Kombinierbarkeit mit {{{ATTRIBUTE}}} {{{OPTION}}} wurden mehr als {{{ATTRIBUTE_COUNT}}} Optionen abgewählt.";
var fullRangedHelperText = "{{{MINIMUM}}} {{{UNIT}}} bis {{{MAXIMUM}}} {{{UNIT}}}";
var rangePartialRangedHelperText = "Mindestens {{{MINIMUM}}} {{{UNIT}}}";
var fullRangedHelperTextForBooklets = "Geben Sie einen Wert zwischen {{{MINIMUM}}} und {{{MAXIMUM}}} für die Anzahl Seiten ein, einschließlich Einband ";
var rangePartialRangedHelperTextForBooklets = "Mindestens {{{MINIMUM}}} Seiten, einschließlich Einband ";
var rangedGeneralInputError = "Eingabe ist ungültig";
var rangedBetweenRangesError = "Die nächsten Werte sind {{{LOWER}}} {{{UNIT}}} und {{{HIGHER}}} {{{UNIT}}}.";
var rangedDecimalPrecisionError = "Die Zahl darf nicht mehr als acht Dezimalstellen aufweisen.";
var rangedMinInputValueError = "Die kleinste Zahl ist {{{MINIMUM}}} {{{UNIT}}}.";
var rangedMaxInputValueError = "Die größte Zahl ist {{{MAXIMUM}}} {{{UNIT}}}.";
var rangedNotANumberError = "Eingabe muss eine Zahl sein";
var requiredAttributeFieldError = "Geben Sie einen Wert zwischen {{{LOWER}}} und {{{HIGHER}}} {{{UNIT}}} ein";
var rangedBetweenRangesErrorForBooklets = "Die nächstkleinere Zahl ist {{{LOWER}}} Seiten und die nächstgrößere {{{HIGHER}}} Seiten ";
var rangedMinInputValueErrorForBooklets = "Die kleinste Zahl ist {{{MINIMUM}}} Seiten ";
var rangedMaxInputValueErrorForBooklets = "Die größte Zahl ist {{{MAXIMUM}}} Seiten ";
var requiredAttributeFieldErrorForBooklets = "Geben Sie einen Wert zwischen {{{LOWER}}} und {{{HIGHER}}} für die Anzahl Seiten ein, einschließlich Einband ";
var requiredInformationToast = "Bitte geben Sie alle notwendigen Informationen an.";
var deDe = {
	quantityLabel: quantityLabel,
	quantityFlyoutHeader: quantityFlyoutHeader,
	quantityFlyoutCTA: quantityFlyoutCTA,
	closeButton: closeButton,
	pricePlaceholder: pricePlaceholder,
	priceLabel: priceLabel,
	unitPriceLabel: unitPriceLabel,
	incompatibilityMessage: incompatibilityMessage,
	select: select,
	percentSavings: percentSavings,
	sale: sale,
	amountSavings: amountSavings,
	amountSavingsWithSale: amountSavingsWithSale,
	seeMoreQuantities: seeMoreQuantities,
	required: required,
	sample: sample,
	estimatedQuantity: estimatedQuantity,
	numberOfRecipients: numberOfRecipients,
	recommendedCallout: recommendedCallout,
	newCallout: newCallout,
	incompatibleLabel: incompatibleLabel,
	outOfStockCallout: outOfStockCallout,
	dismissAlert: dismissAlert,
	unwindingMessage_1: unwindingMessage_1,
	unwindingMessage_2: unwindingMessage_2,
	unwindingMessage_3: unwindingMessage_3,
	unwindingMessage_more: unwindingMessage_more,
	unwindingAlertMessage_1: unwindingAlertMessage_1,
	unwindingAlertMessage_2: unwindingAlertMessage_2,
	unwindingAlertMessage_3: unwindingAlertMessage_3,
	unwindingAlertMessage_more: unwindingAlertMessage_more,
	fullRangedHelperText: fullRangedHelperText,
	rangePartialRangedHelperText: rangePartialRangedHelperText,
	fullRangedHelperTextForBooklets: fullRangedHelperTextForBooklets,
	rangePartialRangedHelperTextForBooklets: rangePartialRangedHelperTextForBooklets,
	rangedGeneralInputError: rangedGeneralInputError,
	rangedBetweenRangesError: rangedBetweenRangesError,
	rangedDecimalPrecisionError: rangedDecimalPrecisionError,
	rangedMinInputValueError: rangedMinInputValueError,
	rangedMaxInputValueError: rangedMaxInputValueError,
	rangedNotANumberError: rangedNotANumberError,
	requiredAttributeFieldError: requiredAttributeFieldError,
	rangedBetweenRangesErrorForBooklets: rangedBetweenRangesErrorForBooklets,
	rangedMinInputValueErrorForBooklets: rangedMinInputValueErrorForBooklets,
	rangedMaxInputValueErrorForBooklets: rangedMaxInputValueErrorForBooklets,
	requiredAttributeFieldErrorForBooklets: requiredAttributeFieldErrorForBooklets,
	requiredInformationToast: requiredInformationToast
};

export { amountSavings, amountSavingsWithSale, closeButton, deDe as default, dismissAlert, estimatedQuantity, fullRangedHelperText, fullRangedHelperTextForBooklets, incompatibilityMessage, incompatibleLabel, newCallout, numberOfRecipients, outOfStockCallout, percentSavings, priceLabel, pricePlaceholder, quantityFlyoutCTA, quantityFlyoutHeader, quantityLabel, rangePartialRangedHelperText, rangePartialRangedHelperTextForBooklets, rangedBetweenRangesError, rangedBetweenRangesErrorForBooklets, rangedDecimalPrecisionError, rangedGeneralInputError, rangedMaxInputValueError, rangedMaxInputValueErrorForBooklets, rangedMinInputValueError, rangedMinInputValueErrorForBooklets, rangedNotANumberError, recommendedCallout, required, requiredAttributeFieldError, requiredAttributeFieldErrorForBooklets, requiredInformationToast, sale, sample, seeMoreQuantities, select, unitPriceLabel, unwindingAlertMessage_1, unwindingAlertMessage_2, unwindingAlertMessage_3, unwindingAlertMessage_more, unwindingMessage_1, unwindingMessage_2, unwindingMessage_3, unwindingMessage_more };
//# sourceMappingURL=de-de.json.mjs.map
